import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { store } from "./Store";
import { NetworkAPI } from "../services/api/network";


const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), delay);
  };
};


const fetchWithTimeout = (timeout = 5000, abortSignal = null) =>
  Promise.race([
    NetworkAPI.checkNetworkStatus({abortSignal}), 
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Timeout")), timeout)
    ),
  ]);

export const NetworkStatusDetector = ({ children }) => {
  const { dispatch } = useContext(store);
  const [online, setOnline] = useState(undefined);
  const memoOnline = useMemo(() => online, [online]);
  const abortControllerRef = useRef(null);


  const detectNetwork = async () => {
    try {
      const response = await fetchWithTimeout(5000, abortControllerRef.current?.signal);
      if (response) {
        console.log("Conexión activa");
        setOnline(true);
      } else {
        console.log("Sin conexión");
        setOnline(false);
      }
    } catch (error) {
      console.error("Error en la verificación de conexión:", error);
      setOnline(false);
    }
  };

  useEffect(() => {
    dispatch({
      type: "CHANGE_VALUE",
      property: "isOnline",
      value: memoOnline,
    });
  }, [memoOnline, dispatch]);

  useEffect(() => {
    const debouncedCheckConnection = debounce(() => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      abortControllerRef.current = new AbortController();
      detectNetwork();
    }, 2000);


    debouncedCheckConnection();


    const intervalId = setInterval(debouncedCheckConnection, 5000);

    return () => {
      clearInterval(intervalId);
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return children;
};
